import { render } from "./product_category.vue?vue&type=template&id=081f0a3c&scoped=true"
import script from "./product_category.vue?vue&type=script&lang=js"
export * from "./product_category.vue?vue&type=script&lang=js"

import "./product_category.vue?vue&type=style&index=0&id=081f0a3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081f0a3c"]])

export default __exports__